import { useSearchParams } from 'react-router-dom';

export const useInstantRedirectProdId = () => {
  const [urlSearchParams] = useSearchParams();
  const subdominioParam = urlSearchParams.get('customProductId');

  if (subdominioParam) return subdominioParam;
  return null;
};
